export default __webpack_public_path__ + "static/media/familyRoom.808a5252.jpg";